import { type ElementType } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { DropdownThreeDotsIcon } from '@hivebrite/design-system/Dropdown';

interface DropdownButtonProps {
  items: Array<{
    dataTestId?: string;
    icon: ElementType;
    label: string;
    onClick: () => void;
  }>;
  title: string;
}

const DropdownButton = ({ items, title }: DropdownButtonProps) => (
  <Box display="block">
    <DropdownThreeDotsIcon
      dataTestId="dropdown-forum-discussion"
      items={items}
      title={s__(
        'ForumAccessibility|Action dropdown to discussion %{title}',
      ).i__({
        title,
      })}
    />
  </Box>
);

export default DropdownButton;
